// src/components/dashboard/ActivitySummary.jsx
import { useState } from "react";

export default function ActivitySummary() {
  const [showRecentlyViewed, setShowRecentlyViewed] = useState(false);

  const activities = [
    {
      title: "Saved Suppliers",
      img: "/assets/images/SavedSupplier.png",
    },
    {
      title: "Ongoing Quote Requests",
      img: "/assets/images/RequestQuotation.png",
    },
    {
      title: "Recently Viewed Products",
      img: "/assets/images/RecentlyViewed.png",
    },
  ];

  const recentlyViewed = [
    {
      title: "Coffee Table",
      brand: "Ikea",
      img: "/assets/images/coffeeTable.png",
    },
    {
      title: "Hyaluronic Face Cream 50ml",
      brand: "Lumo",
      img: "/assets/images/faceCreamLumo.png",
    },
    {
      title: "JBL Go 3 - Portable Mini Bluetooth Speaker",
      brand: "JBL",
      img: "/assets/images/jbl.png",
    },
    {
      title: "Vitamin C Face Serum",
      brand: "Essentia",
      img: "/assets/images/VitCSerum.png",
    },
    {
      title: "Eye Revive Cream",
      brand: "Luxe",
      img: "/assets/images/EyeCreamLuxe.png",
    },
  ];

  return (
    <section className="py-10" style={{ backgroundColor: "rgba(248, 246, 250, 85)" }}
>
      <div className="max-w-[1200px] mx-auto px-6">
        <h2 className="text-2xl font-semibold text-center mb-8">
          Your Activity Summary
        </h2>

        {/* Card Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {activities.map((item, idx) => (
            <div
              key={idx}
              className="bg-white rounded-xl shadow-md overflow-hidden hover:shadow-lg transition"
            >
              <img
                src={item.img}
                alt={item.title}
                className="w-full h-40 object-cover"
              />
              <div className="p-4 flex flex-col items-center">
                <p className="font-medium mb-2">{item.title}</p>
                {item.title === "Recently Viewed Products" ? (
                  <button
                    onClick={() => setShowRecentlyViewed(!showRecentlyViewed)}
                    className="px-4 py-2 border rounded-lg text-sm font-medium text-rose-600 hover:bg-rose-50 transition"
                  >
                    {showRecentlyViewed ? "Hide" : "View →"}
                  </button>
                ) : (
                  <button className="px-4 py-2 border rounded-lg text-sm font-medium text-rose-600 hover:bg-rose-50 transition">
                    View →
                  </button>
                )}
              </div>
            </div>
          ))}
        </div>

        {/* Recently Viewed Toggle */}
        <div
          className={`transition-all duration-500 overflow-hidden ${
            showRecentlyViewed ? "max-h-[1000px] mt-10" : "max-h-0"
          }`}
        >
          <h3 className="text-xl font-semibold mb-6 text-center">
            Recently Viewed
          </h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-6">
            {recentlyViewed.map((p, idx) => (
              <div
                key={idx}
                className="bg-white rounded-xl shadow-sm overflow-hidden"
              >
                <img
                  src={p.img}
                  alt={p.title}
                  className="w-full h-36 object-cover"
                />
                <div className="p-3 text-center">
                  <p className="font-medium text-sm">{p.title}</p>
                  <p className="text-gray-500 text-xs">{p.brand}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
